import DialogContentText from "@mui/material/DialogContentText";
import React from "react";

import GenericModal from "../../components/modal-closebtn";
import { language } from "../../language";

const ModelerDecisionModal = ({
  openDialog,
  handleDialogClose,
  handleOk,
  cellData,
}) => {
  const handleCloseDialog = () => {
    handleDialogClose(true, cellData);
  };

  const handleOkClick = () => {
    handleOk(cellData);
    handleDialogClose(false);
  };

  return (
    <GenericModal
      title={language.modalConfirmReplaceTitle}
      handleSubmit={handleOkClick}
      handleClose={handleCloseDialog}
      btnActionTitle={language.confirm}
      btnCancelTitle={language.cancelDelete}
      size="xs"
      open={openDialog}
    >
      <DialogContentText className="text-center" id="alert-dialog-description">
        {language.modalConfirmReplaceItemMessage}
      </DialogContentText>
    </GenericModal>
  );
};

export { ModelerDecisionModal };
